import { LEARN } from 'constants/actionTypes';

export function setSourcePage(sourcePage) {
  return {
    type: LEARN.SEARCH.SET_SOURCE_PAGE,
    sourcePage,
  };
}

export function resetSourcePage() {
  return {
    type: LEARN.SEARCH.RESET_SOURCE_PAGE,
  };
}

export function updateQuery(query) {
  return {
    type: LEARN.SEARCH.UPDATE_QUERY,
    query,
  };
}

export function filterByTopic(topicId) {
  return {
    type: LEARN.SEARCH.UPDATE_FILTER,
    name: 'topic',
    value: {
      id: topicId,
    },
  };
}

export function filterByProgress(value) {
  return {
    type: LEARN.SEARCH.UPDATE_FILTER,
    name: 'progress',
    value,
  };
}

export function resetFilters() {
  return {
    type: LEARN.SEARCH.RESET_FILTERS,
  };
}
